import { useState, useEffect } from 'react';

const useNetworkStatus = (): { isOnline: boolean } => {
  const [isOnline, setIsOnline] = useState<boolean>(() => {
    if (typeof globalThis !== 'undefined' && typeof navigator !== 'undefined') {
      return navigator.onLine;
    }
    return true; 
  });

  const updateNetworkStatus = () => {
    if (typeof navigator !== 'undefined') {
        setIsOnline(navigator.onLine);
    }
  };

  useEffect(() => {
    if (typeof globalThis === 'undefined') {
      return;
    }

    updateNetworkStatus();

    globalThis.addEventListener('online', updateNetworkStatus);
    globalThis.addEventListener('offline', updateNetworkStatus);

    return () => {
      globalThis.removeEventListener('online', updateNetworkStatus);
      globalThis.removeEventListener('offline', updateNetworkStatus);
    };
  }, []); 

  return { isOnline };
};

export default useNetworkStatus;

